import { jsx, jsxs } from "react/jsx-runtime";
import { FieldSet, Flex, LabeledControl, Checkbox, Label, FormHelp } from "@zillow/constellation";
import { useFormContext, useFormState } from "react-hook-form";
import FieldTooltip from "./FieldTooltip.esm.js";
function CheckboxField({
  config,
  description,
  disabled,
  label,
  name,
  onChange,
  tooltip
}) {
  var _a;
  const form = useFormContext();
  const proxyFormState = useFormState();
  const error = (_a = proxyFormState == null ? void 0 : proxyFormState.errors[name]) == null ? void 0 : _a.message;
  const field = form.register(name, config);
  return /* @__PURE__ */ jsx(FieldSet, { description: /* @__PURE__ */ jsx(FormHelp, { error: Boolean(error), children: error || description }), children: /* @__PURE__ */ jsxs(Flex, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ jsx(LabeledControl, { label: /* @__PURE__ */ jsx(Label, { children: label }), control: /* @__PURE__ */ jsx(Checkbox, { ...field, disabled, onChange: (e) => {
      field.onChange(e);
      onChange == null ? void 0 : onChange(e);
    } }) }),
    tooltip && /* @__PURE__ */ jsx(FieldTooltip, { ...tooltip })
  ] }) });
}
export {
  CheckboxField as default
};
